"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _classnames2 = _interopRequireDefault(require("classnames"));
var _reactDom = _interopRequireDefault(require("react-dom"));
var _utils = require("../utils");
var _Button = _interopRequireDefault(require("../Button"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); } /* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* babel-plugin-inline-import './close.svg' */
var CloseImg = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHhtbG5zOnhsaW5rPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5L3hsaW5rIiB3aWR0aD0iMjQiIGhlaWdodD0iMjQiPjxkZWZzPjxwYXRoIGlkPSJhIiBkPSJNNi4xOCA0Ljk5OWwzLjU3NiAzLjU3NmEuODMzLjgzMyAwIDExLTEuMTc4IDEuMTc4TDUgNi4xNzcgMS40MjIgOS43NTZBLjgzMy44MzMgMCAwMS4yNDQgOC41NzhsMy41OC0zLjU4TC4yNDYgMS40MjNBLjgzMy44MzMgMCAxMTEuNDI1LjI0NEw1IDMuODIgOC41NzUuMjQ3YS44MzMuODMzIDAgMDExLjE3OCAxLjE3OEw2LjE4IDQuOTk5eiIvPjwvZGVmcz48ZyBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHRyYW5zZm9ybT0idHJhbnNsYXRlKDcgNykiPjxtYXNrIGlkPSJiIiBmaWxsPSIjZmZmIj48dXNlIHhsaW5rOmhyZWY9IiNhIi8+PC9tYXNrPjx1c2UgZmlsbD0iIzRBOTBFMiIgeGxpbms6aHJlZj0iI2EiLz48ZyBmaWxsPSIjMjkyNjIzIiBtYXNrPSJ1cmwoI2IpIj48cGF0aCBkPSJNLTYtNmgyMnYyMkgtNnoiLz48L2c+PC9nPjwvc3ZnPg==";
var body = document.getElementsByTagName('body')[0];
var Popup = /*#__PURE__*/function (_PureComponent) {
  _inherits(Popup, _PureComponent);
  var _super = _createSuper(Popup);
  function Popup() {
    var _this;
    _classCallCheck(this, Popup);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      open: true
    });
    _defineProperty(_assertThisInitialized(_this), "popup", void 0);
    _defineProperty(_assertThisInitialized(_this), "aside", null);
    _defineProperty(_assertThisInitialized(_this), "x", 0);
    _defineProperty(_assertThisInitialized(_this), "y", 0);
    _defineProperty(_assertThisInitialized(_this), "move", false);
    _defineProperty(_assertThisInitialized(_this), "checkOutsideClick", function (e) {
      var _this$props$getTrigge, _this$props, _this$props$getTrigge2;
      if (_this.props.closeOnClickOutside && !_this.aside.contains(e.target) && !((_this$props$getTrigge = (_this$props = _this.props).getTriggerNode) !== null && _this$props$getTrigge !== void 0 && (_this$props$getTrigge2 = _this$props$getTrigge.call(_this$props)) !== null && _this$props$getTrigge2 !== void 0 && _this$props$getTrigge2.contains(e.target))) {
        _this.props.onClose();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseDown", function (ev) {
      if (!_this.props.move) return;
      _this.move = true;
      _this.x = ev.clientX;
      _this.y = ev.clientY;
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseMove", function (ev) {
      if (!_this.move || !_this.popup) return;
      _this.popup.style.left = Number(_this.popup.offsetLeft + (ev.clientX - _this.x)) + 'px';
      _this.popup.style.top = Number(_this.popup.offsetTop + (ev.clientY - _this.y)) + 'px';
      //If its centered need to remove margin
      _this.popup.style.margin = 'initial';
      _this.x = ev.clientX;
      _this.y = ev.clientY;
    });
    _defineProperty(_assertThisInitialized(_this), "onMouseUp", function () {
      _this.move = false;
    });
    _defineProperty(_assertThisInitialized(_this), "onPrevent", function (ev) {
      if (_this.props.move) {
        ev.stopPropagation();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onContainerClick", function (ev) {
      if (!_this.props.onClose) return;
      var el = ev.target;
      var closePopup = true;
      if (_this.props.stopPropagation) ev.stopPropagation();

      //Is this click inside popup?
      while (el) {
        if (el.classList.contains('popup')) {
          closePopup = false;
        }
        el = el.parentElement;
      }
      if (closePopup) {
        _this.props.onClose();
      }
    });
    _defineProperty(_assertThisInitialized(_this), "onKeypress", function (e) {
      // close function
      if (e.key === 'Escape' && _this.props.onClose) {
        _this.props.onClose();
      }

      // tabbing between focusable elements
      _this.aside && (0, _utils.trapBrowserFocusToElement)(e, _this.aside);
    });
    _defineProperty(_assertThisInitialized(_this), "getStyle", function () {
      var style = {};
      var _this$props2 = _this.props,
        top = _this$props2.top,
        left = _this$props2.left,
        right = _this$props2.right,
        bottom = _this$props2.bottom;
      if (top) style.top = top + 'px';
      if (left) style.left = left + 'px';
      if (right) style.right = right + 'px';
      if (bottom) style.bottom = bottom + 'px';
      return style;
    });
    return _this;
  }
  _createClass(Popup, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3,
        _this$props3$onOpen,
        _this2 = this,
        _this$props$getTrigge3,
        _this$props4;
      (_this$props3 = this.props) === null || _this$props3 === void 0 ? void 0 : (_this$props3$onOpen = _this$props3.onOpen) === null || _this$props3$onOpen === void 0 ? void 0 : _this$props3$onOpen.call(_this$props3);
      if (this.props.closeOnClickOutside) {
        if (!this.props.onClose) {
          console.warn("closeOnClickOutside prop given in popup without onClose function.");
        }
        document.addEventListener('mousedown', this.checkOutsideClick, false);
      }
      if (this.props.move) {
        this.onMouseUp = this.onMouseUp.bind(this);
        this.onMouseMove = this.onMouseMove.bind(this);
        body.addEventListener('mouseup', this.onMouseUp);
        body.addEventListener('mousemove', this.onMouseMove);
        if (this.props.noShadow && this.props.center) {
          this.popup.style.top = (body.offsetHeight - this.popup.offsetHeight) / 2 + 'px';
          this.popup.style.bottom = 'initial';
        }
      }
      this.popup.style.maxHeight = Number(window.innerHeight - this.popup.offsetTop - 10) + 'px';
      setTimeout(function () {
        var _this2$popup;
        if (_this2.props.noFocusOnOpen) return;
        var popupElement = (_this2$popup = _this2.popup) === null || _this2$popup === void 0 ? void 0 : _this2$popup.querySelector('button, input');
        if (popupElement) {
          popupElement.focus();
        } else {
          var _this2$aside;
          (_this2$aside = _this2.aside) === null || _this2$aside === void 0 ? void 0 : _this2$aside.focus();
        }
      }, 50);
      (_this$props$getTrigge3 = (_this$props4 = this.props).getTriggeredPopup) === null || _this$props$getTrigge3 === void 0 ? void 0 : _this$props$getTrigge3.call(_this$props4, this.popup);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.props.move) {
        body.removeEventListener('mouseup', this.onMouseUp);
        body.removeEventListener('mousemove', this.onMouseMove);
      }
      if (this.props.closeOnClickOutside) {
        document.removeEventListener('mousedown', this.checkOutsideClick, false);
      }
      this.props.onClose && this.props.onClose();
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;
      if (!this.state.open) return null;
      var _this$props5 = this.props,
        move = _this$props5.move,
        close = _this$props5.close,
        center = _this$props5.center,
        noShadow = _this$props5.noShadow,
        small = _this$props5.small,
        className = _this$props5.className,
        closeOnClick = _this$props5.closeOnClick,
        fromCenter = _this$props5.fromCenter,
        onClose = _this$props5.onClose,
        children = _this$props5.children,
        title = _this$props5.title;
      var containerClasses = (0, _classnames2.default)(_defineProperty({
        'popup-container': true,
        'no-shadow': !!noShadow,
        'small': !!small,
        'centered-popup': fromCenter,
        move: !!move,
        center: !!center
      }, className, !!className));
      return /*#__PURE__*/_reactDom.default.createPortal( /*#__PURE__*/_react.default.createElement("div", {
        className: containerClasses
      }, /*#__PURE__*/_react.default.createElement("aside", {
        ref: function ref(r) {
          return _this3.aside = r;
        },
        title: title,
        role: "dialog",
        tabIndex: -1,
        style: this.getStyle(),
        className: "popup",
        onMouseDown: move ? this.onMouseDown : undefined,
        onClick: this.onContainerClick,
        onKeyDown: this.onKeypress
      }, close ? /*#__PURE__*/_react.default.createElement(_Button.default, {
        elastic: true,
        className: "popup-close",
        onClick: onClose
      }, /*#__PURE__*/_react.default.createElement("img", {
        src: CloseImg,
        alt: "close"
      })) : null, /*#__PURE__*/_react.default.createElement("div", {
        ref: function ref(r) {
          return _this3.popup = r;
        },
        className: "popup-inner",
        onClick: closeOnClick && onClose ? function () {
          return onClose();
        } : function () {}
      }, children))), body);
    }
  }]);
  return Popup;
}(_react.PureComponent);
exports.default = Popup;
_defineProperty(Popup, "defaultProps", {
  small: false,
  center: false,
  move: false,
  closeOnClickOutside: false,
  closeOnClick: false,
  stopPropagation: true,
  close: false,
  noShadow: false,
  onClose: function onClose() {},
  onOpen: undefined
});